/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Box } from "@nordcloud/gnui";
import DedicatedEmail from "~/components/BasicCustomerInfo/BasicInfoComponents/DedicatedEmail";
import { Customer } from "~/components/BasicCustomerInfo/types";

type Props = {
  customer: Customer;
  onSubmit: (values: Customer) => Promise<void>;
  canEdit: boolean;
};

function DedicatedEmails({ customer, onSubmit, canEdit }: Props) {
  return (
    <>
      <Box border="danger" color="red" mb={3}>
        Usage of these emails is non-standard and needs to be agreed with
        Process Owners and the ITSM team.
      </Box>

      <DedicatedEmail
        field="raiseAlarmEmail"
        title="Raise Alarm Email"
        customer={customer}
        onSubmit={onSubmit}
        canEdit={canEdit}
      />
      <DedicatedEmail
        field="serviceRequestEmail"
        title="Service Request Email"
        customer={customer}
        onSubmit={onSubmit}
        canEdit={canEdit}
      />
    </>
  );
}

export { DedicatedEmails };
